import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Outlet } from 'react-router-dom'

export default function Auth() {
  return (
    <>
      <Helmet>
      <style>
            {`body { 
              background-color: white;
              height: 100%;
           }`}
        </style>
        <style>
          {`html {
              height: 100%;
          }`}
        </style>
      </Helmet>
      <Outlet />   
    </>
  )
}
